/*eslint-disable */
var svgDraw = function (SVG) {
  function a(a, b, c) {
      this.el = a, a.remember("_paintHandler", this);
      var d = this,
          e = this.getPlugin();
      this.parent = a.parent(SVG.Nested) || a.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = null, this.startPoint = null, this.lastUpdateCall = null, this.options = {};
      for (var f in this.el.draw.defaults)
          this.options[f] = this.el.draw.defaults[f], "undefined" != typeof c[f] && (this.options[f] = c[f]);
      for (var f in e)
          this[f] = e[f];
      b || this.parent.on("click.draw", function(a) {
          d.start(a)
      })
  }
  a.prototype.transformPoint = function(a, b) {
      return this.p.x = a - (this.offset.x - window.pageXOffset), this.p.y = b - (this.offset.y - window.pageYOffset), this.p.matrixTransform(this.m)
  }, a.prototype.start = function(a) {
      var b = this;
      this.m = this.el.node.getScreenCTM().inverse(), this.offset = {
          x: window.pageXOffset,
          y: window.pageYOffset
      }, this.options.snapToGrid *= Math.sqrt(this.m.a * this.m.a + this.m.b * this.m.b), this.startPoint = this.snapToGrid(this.transformPoint(a.clientX, a.clientY)), this.init && this.init(a), this.el.fire("drawstart", {
          event: a,
          p: this.p,
          m: this.m
      }), SVG.on(window, "mousemove.draw", function(a) {
          b.update(a)
      }), this.start = this.point
  }, a.prototype.point = function(a) {
      this.stop(a)
  }, a.prototype.stop = function(a) {
      a && this.update(a), this.clean && this.clean(), SVG.off(window, "mousemove.draw"), this.parent.off("click.draw"), this.el.forget("_paintHandler"), this.el.draw = function() {}, this.el.fire("drawstop")
  }, a.prototype.update = function(a) {
      !a && this.lastUpdateCall && (a = this.lastUpdateCall), this.lastUpdateCall = a, this.calc(a), this.el.fire("drawupdate", {
          event: a,
          p: this.p,
          m: this.m
      })
  }, a.prototype.done = function() {
      this.calc(), this.stop(), this.el.fire("drawdone")
  }, a.prototype.cancel = function() {
      this.stop(), this.el.remove(), this.el.fire("drawcancel")
  }, a.prototype.snapToGrid = function(a) {
      var b = null;
      if (a.length) {
          b = [a[0] % this.options.snapToGrid, a[1] % this.options.snapToGrid], a[0] -= b[0] < this.options.snapToGrid / 2 ? b[0] : b[0] - this.options.snapToGrid, a[1] -= b[1] < this.options.snapToGrid / 2 ? b[1] : b[1] - this.options.snapToGrid;
          if (this.options.snapToAxis) {
              var snapped_point = a,
                  points = this.el.array().value;
                  var lastpoint = points[points.length-1];
              return (Math.abs(lastpoint[0]-snapped_point[0]) < Math.abs(lastpoint[1]-snapped_point[1]))? [lastpoint[0],snapped_point[1]]: [snapped_point[0],lastpoint[1]];
          } else {
              return a;
          }
      }
      for (var c in a)
          b = a[c] % this.options.snapToGrid, a[c] -= (b < this.options.snapToGrid / 2 ? b : b - this.options.snapToGrid) + (0 > b ? this.options.snapToGrid : 0);
      return a
  }, a.prototype.param = function(a, b) {
      this.options[a] = null === b ? this.el.draw.defaults[a] : b, this.update()
  }, a.prototype.getPlugin = function() {
      return this.el.draw.plugins[this.el.type]
  }, SVG.extend(SVG.Element, {
      draw: function(b, c, d) {
          b instanceof Event || "string" == typeof b || (c = b, b = null);
          var e = this.remember("_paintHandler") || new a(this, b, c || {});
          return b instanceof Event && e.start(b), e[b] && e[b](c, d), this
      }
  }), SVG.Element.prototype.draw.defaults = {
      snapToGrid: 1,
      snapToAxis: 0
  }, SVG.Element.prototype.draw.extend = function(a, b) {
      var c = {};
      "string" == typeof a ? c[a] = b : c = a;
      for (var d in c) {
          var e = d.trim().split(/\s+/);
          for (var f in e)
              SVG.Element.prototype.draw.plugins[e[f]] = c[d]
      }
  }, SVG.Element.prototype.draw.plugins = {}, SVG.Element.prototype.draw.extend("rect image", {
      init: function() {
          var a = this.startPoint;
          this.el.attr({
              x: a.x,
              y: a.y,
              height: 1,
              width: 1
          })
      },
      calc: function(a) {
          var b = {
                  x: this.startPoint.x,
                  y: this.startPoint.y
              },
              c = this.transformPoint(a.clientX, a.clientY);
          b.width = c.x - b.x, b.height = c.y - b.y, this.snapToGrid(b), b.width < 1 && (b.x = b.x + b.width, b.width = -b.width), b.height < 1 && (b.y = b.y + b.height, b.height = -b.height), this.el.attr(b)
      }
  }), SVG.Element.prototype.draw.extend("line polyline polygon", {
      init: function() {
          this.set = new SVG.Set;
          var a = this.startPoint,
              b = [[a.x, a.y], [a.x, a.y]];
          this.el.plot(b), this.drawCircles(this.el.array().valueOf())
      },
      calc: function(a) {
          var b = this.el.array().valueOf();
          if (b.pop(), a) {
              var c = this.transformPoint(a.clientX, a.clientY);
              b.push(this.snapToGrid([c.x, c.y]))
          }
          this.el.plot(b)
      },
      point: function(a) {
          if (this.el.type.indexOf("poly") > -1) {
              var b = this.transformPoint(a.clientX, a.clientY),
                  c = this.el.array().valueOf();
              return c.push(this.snapToGrid([b.x, b.y])), this.el.plot(c), this.drawCircles(this.el.array().valueOf().slice(0,-1)), void this.el.fire("drawpoint", {
                  event: a,
                  p: {
                      x: b.x,
                      y: b.y
                  },
                  m: this.m
              })
          }
          this.stop(a)
      },
      clean: function() {
          this.set.each(function() {
              this.remove()
          }), this.set.clear(), delete this.set
      },
      drawCircles: function(a) {
          this.set.each(function() {
              this.remove()
          }), this.set.clear();
          var b = this.parent.node.getBoundingClientRect();
          b.x -= this.offset.x - window.pageXOffset, b.y -= this.offset.y - window.pageYOffset;
          for (var c = 0; c < a.length; ++c) {
              this.p.x = a[c][0], this.p.y = a[c][1];
              var d = this.p.matrixTransform(this.m.inverse());
              this.set.add(this.parent.circle(5).stroke({
                  width: 1,
                  color: a.length > 2 && c ? "#000" : "#5F74FE"
              }).fill(a.length > 2 && c ? "#000" : "#5F74FE").center(d.x - b.x, d.y - b.y))
          }
      }
  }), SVG.Element.prototype.draw.extend("circle", {
      init: function() {
          var a = this.startPoint;
          this.el.attr({
              cx: a.x,
              cy: a.y,
              r: 1
          })
      },
      calc: function(a) {
          var b = this.transformPoint(a.clientX, a.clientY),
              c = {
                  cx: this.startPoint.x,
                  cy: this.startPoint.y,
                  r: Math.sqrt((b.x - this.startPoint.x) * (b.x - this.startPoint.x) + (b.y - this.startPoint.y) * (b.y - this.startPoint.y))
              };
          this.snapToGrid(c), this.el.attr(c)
      }
  }), SVG.Element.prototype.draw.extend("ellipse", {
      init: function() {
          var a = this.startPoint;
          this.el.attr({
              cx: a.x,
              cy: a.y,
              rx: 1,
              ry: 1
          })
      },
      calc: function(a) {
          var b = this.transformPoint(a.clientX, a.clientY),
              c = {
                  cx: this.startPoint.x,
                  cy: this.startPoint.y,
                  rx: Math.abs(b.x - this.startPoint.x),
                  ry: Math.abs(b.y - this.startPoint.y)
              };
          this.snapToGrid(c), this.el.attr(c)
      }
  })

}

export default svgDraw;
/*eslint-enable */
